import script from "./AttorneySignupView.vue?vue&type=script&setup=true&lang=js"
export * from "./AttorneySignupView.vue?vue&type=script&setup=true&lang=js"

import "./AttorneySignupView.vue?vue&type=style&index=0&id=14663bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14663bca"]])

export default __exports__